import Pusher from 'pusher-js';
import { Observable, shareReplay, switchMap } from 'rxjs';
import { PUSHER_CLUSTER, PUSHER_CLIENT_KEY } from 'config/environment';
import { ApiKey } from 'services';
import { authorizer } from './authorizer';
const pusher$ = ApiKey.tokens().pipe(switchMap(()=>new Observable((subscriber)=>{
        const pusher = new Pusher(PUSHER_CLIENT_KEY, {
            auth: {
                headers: ApiKey.header()
            },
            cluster: PUSHER_CLUSTER,
            authorizer: authorizer()
        });
        subscriber.next(pusher);
        return ()=>pusher.disconnect();
    })), shareReplay(1));
export const client = ()=>pusher$;
